module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "article"
  }, [_c('article', {
    staticClass: "article-content"
  }, [_c('ext-link', {
    staticClass: "article-content__link",
    attrs: {
      "to": _vm.to
    }
  }, [_c('h3', {
    staticClass: "article-content__link_title",
    staticStyle: {
      "-webkit-box-orient": "vertical"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), (_vm.cop_multi_name) ? _c('div', {
    staticClass: "article-content_cop"
  }, [_c('p', {
    staticClass: "multiCopText",
    attrs: {
      "title": "cop_multi_name"
    }
  }, [_vm._v(_vm._s(_vm.cop_multi_name))])]) : _vm._e(), _c('img', {
    staticClass: "article-content__link_img",
    attrs: {
      "src": _vm.middleThumb,
      "alt": _vm.title
    }
  })]), _c('div', {
    staticClass: "sidebar__event_type"
  }, [_vm._v(_vm._s(_vm.getEventType))]), _c('div', {
    staticClass: "article-content__desc",
    staticStyle: {
      "-webkit-box-orient": "vertical"
    }
  }, [_vm._v(_vm._s(_vm.desc))])], 1), _c('aside', {
    staticClass: "article-footer"
  }, [_c('div', {
    staticClass: "article-footer_info-box"
  }, [_c('div', {
    staticClass: "info-item view"
  }, [_vm._v(_vm._s(_vm.view))]), _c('div', {
    staticClass: "info-item comments"
  }, [_vm._v(_vm._s(_vm.comments))])]), _c('AppButtonNew', {
    staticClass: "article-footer_btn",
    attrs: {
      "to": _vm.to,
      "color": "#79E090",
      "color-hover": "#54CB6E"
    }
  }, [_vm._v("Прочитать")])], 1), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c085247","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/blog/list/components/Item.vue
// module id = dd96354c56bc66d22758
// module chunks = 0